// extracted by mini-css-extract-plugin
module.exports = {"table-row-active":"index_table-row-active__Uc6ge","menu-logo":"index_menu-logo__3K7VJ","menu":"index_menu__PyrAb","list-focus":"index_list-focus__3mVZ0"};